import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cluster-hlist" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "action" }
const _hoisted_5 = { class: "hlist hide-scrollbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Cluster = _resolveComponent("Cluster")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.link)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.link
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'View all')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusters, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item cluster--rounded", { 'cluster--circle': _ctx.circle(item) }]),
          key: item.cluster_id
        }, [
          _createVNode(_component_Cluster, {
            data: item,
            link: true,
            counters: !_ctx.routeIsExplore
          }, null, 8, ["data", "counters"])
        ], 2))
      }), 128))
    ])
  ]))
}